import React, { FC } from 'react'

const ThumbnailsUpIcon: FC = () => (
  <svg
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="15"
      cy="15"
      r="14.5"
      transform="rotate(90 15 15)"
      fill="white"
      stroke="#E5E5EA"
    />
    <path
      d="M17.1496 16.5988L15 14.4499L12.8504 16.5988C12.4843 16.9649 11.8907 16.9649 11.5246 16.5988C11.1585 16.2327 11.1585 15.6391 11.5246 15.273L14.3371 12.4605C14.4779 12.3196 14.6524 12.233 14.8346 12.2005L14.9447 12.1875L15.0553 12.1875C15.2765 12.2005 15.4939 12.2915 15.6629 12.4605L18.4754 15.273C18.8415 15.6391 18.8415 16.2327 18.4754 16.5988C18.1093 16.9649 17.5157 16.9649 17.1496 16.5988Z"
      fill="#8E8E93"
    />
  </svg>
)

export default ThumbnailsUpIcon
